module.exports = __webpack_public_path__ + "static/blog-banner-616908446c3ab647e06e77e332bffa35.png";